var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.nameSettings.hasActiveFields()
    ? _c(
        "w-row",
        [
          _c(
            "w-col",
            {
              staticClass: "input-container",
              style: { paddingBottom: "1px" },
              attrs: { xs: "12", md: "12" },
            },
            _vm._l(_vm.numKeys, function (key) {
              return _c("w-input-number", {
                key: key,
                attrs: {
                  fancy: "",
                  label: _vm.getLabel(key),
                  decimals: _vm.getDecimals(key),
                },
                model: {
                  value: _vm.value[key],
                  callback: function ($$v) {
                    _vm.$set(_vm.value, key, $$v)
                  },
                  expression: "value[key]",
                },
              })
            }),
            1
          ),
          _c(
            "w-col",
            { staticClass: "input-container", attrs: { xs: "12", md: "12" } },
            _vm._l(_vm.textKeys, function (key) {
              return _c("app-extra-fields-edit-text", {
                key: key,
                attrs: {
                  config: _vm.getTextConfig(key),
                  fancy: "",
                  label: _vm.getLabel(key),
                },
                model: {
                  value: _vm.value[key],
                  callback: function ($$v) {
                    _vm.$set(_vm.value, key, $$v)
                  },
                  expression: "value[key]",
                },
              })
            }),
            1
          ),
          _vm._l(_vm.formattedTextKeys, function (key) {
            return _c(
              "w-col",
              {
                key: key,
                staticClass: "input-container",
                attrs: { xs: "12", md: "12" },
              },
              [
                _c("div", { staticClass: "formatted-label" }, [
                  _vm._v(_vm._s(_vm.getLabel(key))),
                ]),
                _c("w-editor", {
                  attrs: { height: "300", value: _vm.value[key] || "" },
                  on: {
                    input: function ($event) {
                      _vm.value[key] = $event
                    },
                  },
                }),
              ],
              1
            )
          }),
          _c(
            "w-col",
            {
              staticClass: "input-container bools",
              attrs: { xs: "12", md: "12" },
            },
            _vm._l(_vm.boolKeys, function (key) {
              return _c("w-checkbox", {
                key: key,
                attrs: { fancy: "", label: _vm.getLabel(key) },
                model: {
                  value: _vm.value[key],
                  callback: function ($$v) {
                    _vm.$set(_vm.value, key, $$v)
                  },
                  expression: "value[key]",
                },
              })
            }),
            1
          ),
          _c(
            "w-col",
            { staticClass: "input-container", attrs: { xs: "12", md: "12" } },
            _vm._l(_vm.timeKeys, function (key) {
              return _c("w-date-picker", {
                key: key,
                attrs: {
                  "popover-visibility": "focus",
                  nullable: "",
                  locale: _vm.locale,
                  fancy: "",
                  label: _vm.getLabel(key),
                },
                model: {
                  value: _vm.value[key],
                  callback: function ($$v) {
                    _vm.$set(_vm.value, key, $$v)
                  },
                  expression: "value[key]",
                },
              })
            }),
            1
          ),
        ],
        2
      )
    : _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", center: "" } },
            [
              _c("h4", [
                _vm._v(" " + _vm._s(_vm.$ct("no-active-fields")) + " "),
              ]),
              _c("w-link", { attrs: { to: "/settings/extra-field-names" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("setup-extra-fields")) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }